<template>
  <div class="cpt-electron-title-bar theme-reset" :theme="bar_theme" v-if="showTitleBar">
    <div class="logo">
      <svg width="44" height="12" viewBox="0 0 44 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_4981_119538)">
      <g clip-path="url(#clip1_4981_119538)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.1219 0.572189L18.0167 0.601052C19.2039 1.87628 20.8042 2.76179 22.6045 3.04458C22.6324 3.05375 22.6604 3.0629 22.6885 3.07201L22.6882 3.91178C21.862 3.78525 20.7013 3.59671 20.0762 3.28413V3.59547H15.1306V3.27296C14.4496 3.60787 13.3218 3.79642 12.5292 3.91178L12.5295 3.04109C14.3343 2.75238 15.9369 1.85768 17.1219 0.572189ZM16.0125 2.79292C16.7382 2.3687 17.2629 1.95564 17.609 1.55374C17.955 1.9668 18.4797 2.37986 19.1831 2.79292H16.0125ZM21.0586 5.37051V4.17723H14.1594V6.61092H19.8181C20.5032 6.61092 21.0586 6.05557 21.0586 5.37051ZM19.9645 5.08645C19.9645 5.42898 19.6868 5.70666 19.3443 5.70666H15.2534V5.07032H19.9645V5.08645ZM13.7463 9.59164H12.6411V10.5406H22.5433V9.59164H21.4381V7.16911H13.7463V9.59164ZM15.9679 9.59164H14.8627V7.99399H15.9679V9.59164ZM17.0508 7.99399H18.1448V9.59164H17.0508V7.99399ZM19.2277 7.99399H20.3552V9.59164H19.2277V7.99399ZM11.7505 10.7887C11.6567 10.2243 11.1719 9.58044 10.739 9.08436H9.29937C9.8344 9.76095 10.1744 10.3534 10.3911 10.7887H11.7505ZM9.11727 10.7887C9.07292 10.3841 8.65229 9.63957 8.31216 9.08436H7.02262C7.04889 9.1364 7.0789 9.1939 7.11091 9.25523C7.22274 9.46949 7.35915 9.73084 7.44701 9.97245L7.7363 10.7887H9.11727ZM6.3511 10.7887L6.34675 10.7699C6.2364 10.2943 6.07621 9.60383 5.92539 9.08436H4.7669L5.03564 9.96749C5.10114 10.2669 5.15096 10.5429 5.19166 10.7887H6.3511ZM2.9409 10.7887C3.36953 10.0858 3.66383 9.51769 3.82992 9.08436H2.61922C2.29782 9.63374 1.83895 10.3119 1.48877 10.7887H2.9409ZM3.05354 8.46415H2.9418L1.63318 8.4641V7.43704H5.98208V6.80071H2.33649V5.74015H5.98208V5.14847H2.40844V0.984393H10.909V3.90806C10.909 4.59312 10.3537 5.14847 9.66859 5.14847H7.38003V5.74015H10.981V6.80071H7.38003V7.43704H11.6843V8.4641H10.1697H3.05345L3.05354 8.46415ZM10.1697 8.4641L10.1698 8.46415H10.1696L10.1697 8.4641ZM5.98208 4.08792V1.87625H3.54714V4.08792H5.98208ZM9.77031 1.87625H7.38003V4.08792H9.1501C9.49263 4.08792 9.77031 3.81024 9.77031 3.46771V1.87625ZM4.60632 2.08711H4.60547H4.60458H4.60364H4.60266C4.34931 2.08712 4.11876 2.08714 3.97339 2.08709C4.12843 3.1105 4.71764 3.8857 4.71764 3.8857H5.64795C5.64795 3.8857 5.15178 2.8314 5.15178 2.08709C4.97482 2.08708 4.78755 2.0871 4.61098 2.08711H4.60927H4.60772H4.60632ZM8.73712 2.08711H8.73627H8.73487H8.73331H8.73158C8.55501 2.0871 8.36776 2.08708 8.1908 2.08709C8.1908 2.8314 7.69464 3.8857 7.69464 3.8857H8.62495C8.62495 3.8857 9.21415 3.1105 9.3692 2.08709C9.22364 2.08714 8.99268 2.08712 8.73895 2.08711H8.73801H8.73712ZM40.5209 4.14211H42.0057L43.1241 4.1421V5.23615H33.3782V4.1421L34.8733 4.14211H36.0481C35.879 3.83707 35.6701 3.37938 35.573 2.84712H35.5663L33.9922 2.8471V1.71956H37.6539C37.5646 1.39582 37.4864 1.13905 37.4306 0.96043L38.6698 0.748319C38.7703 1.01625 38.8819 1.34 38.9824 1.71956H42.5213V2.8471L41.003 2.84712H40.996C40.8988 3.37938 40.6899 3.83707 40.5209 4.14211ZM39.5061 4.14211C39.6393 3.79523 39.8075 3.28175 39.832 2.84712H39.7192L36.8278 2.8471L36.737 2.84711C36.7615 3.28173 36.9296 3.79523 37.0629 4.14211H39.5061ZM26.486 7.27044H26.5005V9.87531H26.486V10.5408H27.6581H30.7269C31.412 10.5408 31.9674 9.98544 31.9674 9.30038L31.9674 7.03351H26.486V7.27044ZM27.6581 8.11639V9.38906H30.1415C30.484 9.38906 30.7617 9.11138 30.7617 8.76885V8.11639H27.6581ZM25.7253 3.14605C25.6453 2.55267 25.3601 2.21774 25.0905 1.90112C25.0642 1.87029 25.0381 1.83958 25.0123 1.80888C24.7221 1.4628 24.4541 1.17254 24.2085 0.926939L23.2931 1.66375C23.5052 1.89818 23.7732 2.2331 24.0969 2.65732C24.2953 2.91726 24.3725 3.16697 24.4384 3.38045C24.4801 3.51537 24.5173 3.63582 24.5779 3.73525L25.7253 3.14605ZM28.7299 3.22667L28.8862 2.31124H32.2688V1.25069H25.9947V2.31124H27.7363L27.58 3.22667H26.1734V4.27606H27.4014L27.2116 5.33662H25.6375V6.43067H32.7823V5.33662H31.5989L31.6548 3.22667H28.7299ZM30.4044 5.33662H28.3726L28.5512 4.27606H30.4491L30.4044 5.33662ZM25.191 8.68698L26.1904 7.67357V8.09498V8.94039L26.18 8.95011C26.1432 9.00611 26.1069 9.06557 26.0687 9.1281C25.8921 9.4172 25.6754 9.77197 25.191 10.1544C24.6018 10.6196 24.0414 10.9297 24.0414 10.9297L24.0411 9.03182V5.31429H22.9247V4.20908H25.191V8.68698ZM41.9437 5.968H34.6252V10.5408H40.7033C41.3884 10.5408 41.9437 9.98544 41.9437 9.30038V5.968ZM35.8036 7.02235H40.7653V7.7666H35.8036V7.02235ZM35.8036 8.82096H40.7653V8.945C40.7653 9.28753 40.4876 9.56521 40.1451 9.56521H35.8036V8.82096Z"/>
      </g>
      </g>
      <defs>
      <clipPath id="clip0_4981_119538">
      <rect width="44" height="12" fill="white"/>
      </clipPath>
      <clipPath id="clip1_4981_119538">
      <rect width="57.1484" height="11" fill="white" transform="translate(-14 0.5)"/>
      </clipPath>
      </defs>
      </svg>
    </div>
    <div class="btns" v-if="isClient">
      <i class="iconfont icon-clockwise-bold" @click="refreshWeb"></i>
      <i class="iconfont icon-question-bold" v-remind-to-login="{ cb: openFeedback }"></i>
      <i class="iconfont icon-minimize-bold1" @click="handleWindowOperate('min')"></i>
      <i class="iconfont icon-maximization-bold1" :class="{ 'icon-reduction-bold1': isMax }" @click="handleWindowOperate('max')"></i>
      <i class="iconfont icon-close-bold" @click="handleWindowOperate('close')"></i>
    </div>
    <template v-else>
      <div class="btns">
        <i class="iconfont icon-question-bold" v-remind-to-login="{ cb: openFeedback }"></i>
      </div>
      <DownloadClient></DownloadClient>
    </template>
  </div>
</template>

<script>
import DownloadClient from '../busy/DownloadClient.vue'
import { mapGetters } from 'vuex'
import EventBus from '_lib/EventBus'
import { startMatch } from '_api/team-match'
import {
  RTC_TYPE,
} from '@/common/constants/rtc'
export default {
  components: {
    DownloadClient,
  },
  data() {
    return {
      isMax: false,
    }
  },
  computed: {
    isDev () {
      return !process.env.IS_CLIENT && window.location.href.includes('debugmode')
    },
    showTitleBar() {
      return process.env.IS_CLIENT || window.location.pathname.indexOf('/app') === 0
    },
    ...mapGetters([
      'setting_data',
      'show_theme_data',
      'bar_theme',
      'my_screen_sharing',
      'is_matching',
      'match_params',
    ]),
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      if (process.env.IS_CLIENT && window.electronAPI) {
        window.electronAPI.onMainWindowResize((_event, value) => {
          this.isMax = value
        })
        this.isMax = await window.electronAPI.getIsMainWindowMaximized()
      }
    },
    async handleWindowOperate(type, force) {
      if (type === 'close') {
        if (!this.setting_data.never_show_close_dialog && !force) {
          EventBus.$dynamic('CloseAppDialog', (val) => {
            this.handleWindowOperate(val, true)
          })
          return
        } else {
          type = this.setting_data.close_event
        }
      }
      if(type === 'close') {
        await this.$rtc.closeVoiceRecord();
        await this.cancelMatch()
      }
      window.electronAPI.mainWindowControl(type)
      if (type === 'max') {
        this.isMax = !this.isMax
      }
    },
    async cancelMatch() {
      if(this.is_matching) {
        await startMatch({}, {
          ...this.match_params,
          is_start: false
        })
      }
    },
    async refreshWeb() {
      try {
        if (this.$rtc.RtcType === RTC_TYPE.VOLC_ELECTRON) {
          await this.$rtc.leave()
        } else if(process.env.IS_CLIENT && this.my_screen_sharing && this.$rtc.RtcType === RTC_TYPE.TRTC_ELECTRON) {
          await this.$rtc.stopPreviewScreenCapture()
        }
      } catch(e) {
        console.error(e)
      }
      await this.cancelMatch()
      window.electronAPI.refreshWeb()
    },
    openFeedback() {
      EventBus.$dynamic('UserConfig', 'feedback')
    },
  },
}
</script>
<style lang="scss">
.cpt-electron-title-bar {
  height: 30px;
  width: 100vw;
  z-index: 99999999;
  position: relative;
  display: flex;
  align-items: center;
  -webkit-app-region: drag;
  &.hide {
    display: none;
  }
  .logo {
    width: 44px;
    height: 12px;
    margin-left: 11px;
    margin-right: auto;
    display: flex;
    svg {
      width: 100%;
      height: 100%;
      path {
        fill: $d-op-5;
      }
    }
  }
  .btns {
    -webkit-app-region: none;
    display: flex;
    align-items: center;
    height: 100%;
    float: right;
    i {
      height: 100%;
      width: 30px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background: $d-op-2;
      }
      &::before {
        color: $d-op-4;
        width: 12px;
        height: 12px;
        font-size: 12px;
      }
    }
  }
}


</style>
